<template>
  <div class="el-tab-pane">
    <el-row class="c-stats_row">
      <el-col :span="24" class="c-stats_row_timeseries">
        <top-ten-bar-chart-card
          :class="[isNavLoaded ? 'el-col-24' : 'el-col-20']"
          :chart-id="'dns-stats'"
          :barchart-stats="hrlyStats"
          :top-stats="topStats"
          :bottom-stats="topStats"
          :new-stats="topStats"
          :col-headers="statsCols"
          :default-stats="currentTopTenSelection"
          :stats-loading="isTopTenStatsLoading"
          :chart-loading="isChartLoading"
          @topten-change="changeTopTenSelection"
          @stats-click="getTopTenSelectionInsight"
        ></top-ten-bar-chart-card>
      </el-col>
    </el-row>
    <el-row class="c-stats_row_table">
      <el-col :span="24" class="c-stats_row_timeseries page-table" v-loading="isStatsTableLoading">
        <tree-table-element
          v-if="insightHostStatisticsReqStatus === 'saved'"
          :columns="statsTableColumns"
          :table-data="statsTableData"
          :height-offset="50"
          ref="statsTable"
        ></tree-table-element>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { header } from '@/column-header/statistics'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import BarChartJs from '@/components/chart/BarChartJs.vue'
import HorizontalBarChartJs from '@/components/chart/HorizontalBarChartJs.vue'
import TreeTableElement from '@/components/table/TreeTableElement.vue'
import TopTenBarChartCard from '@/components/card/insights/TopTenBarChartCard.vue'
import IQCollection from '@/resources/collections/IQCollection'

import { HR_TO_MILLISECONDS } from '@/constants/datetime.constants'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import {
  HRLY_INSIGHT_STATISTICS_LIST_RESET_STATUS,
  HRLY_INSIGHT_STATISTICS_LIST_REQ,
  HRLY_INSIGHT_STATISTICS_LIST_SUCCESS,
  TOP_INSIGHT_STATISTICS_LIST_REQ,
  TOP_INSIGHT_STATISTICS_LIST_SUCCESS,
  BOTTOM_INSIGHT_STATISTICS_LIST_REQ,
  BOTTOM_INSIGHT_STATISTICS_LIST_SUCCESS,
  NEW_INSIGHT_STATISTICS_LIST_REQ,
  NEW_INSIGHT_STATISTICS_LIST_SUCCESS,
  INSIGHT_HOST_STATISTICS_LIST_REQ,
  INSIGHT_HOST_STATISTICS_LIST_SUCCESS,
  INSIGHT_HOST_STATISTICS_LIST_RESET_STATUS
} from '@/store/modules/statistics/insight-statistics.type'
import { INSIGHTS_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'

export default {
  name: 'RenderInsights',
  data () {
    let currentRoute = this.$router.currentRoute
    let view = currentRoute.query.view
    let name = currentRoute.meta.name
    let statsCols = currentRoute.meta.statsCols
    let statsTableColumns = header[name].topagents.meta.columns
    return {
      currentTopTenSelection: view || 'new',
      selectedTopTenRow: {},
      statsTableColumns: statsTableColumns,
      loadedStatsRequest: false,
      statsCols: statsCols,
      topStats: {},
      hrlyStats: {},
      statsTableData: {},
      tempHrlyStats: {},
      tempHrlyHostStats: {},
      tempTableData: {},
      isTopTenStatsLoading: false,
      isStatsTableLoading: false
    }
  },
  created () {
    if (_.isEmpty(this.$router.currentRoute.query.view)) {
      this.$router.replace({
        query: _.merge(
          {
            view: 'new'
          },
          this.$router.currentRoute.query
        )
      })
    }
    if (!this.$_.isEmpty(this.$route.query.date_range)) {
      this.$store.dispatch(INSIGHTS_DATE_RANGE_PREFERENCE, this.$route.query.date_range)
    }
    if (this.agentListReqStatus !== 'saved') {
      this.$store.dispatch(AGENT_LIST_REQ).then(agents => {
        this.getHourlyStats()
        this.fetchInsights(this.$router.currentRoute.query.view)
      })
    } else {
      this.getHourlyStats()
      this.fetchInsights(this.$router.currentRoute.query.view)
    }
  },
  methods: {
    changeTopTenSelection (tabSelection) {
      this.$router.replace({
        query: {
          view: tabSelection
        }
      })
      this.hrlyStats = _.cloneDeep(this.tempHrlyStats)
      this.fetchInsights(tabSelection)
    },
    getTopTenSelectionInsight (row) {
      let name = this.$router.currentRoute.meta.name
      let group = this.$router.currentRoute.meta.group
      if (this.selectedTopTenRow !== row) {
        this.selectedTopTenRow = row
        this.statsTableColumns = header[name].agents.meta.columns
        this.getPrivExecHostStats(this.currentTopTenSelection, this.selectedTopTenRow[group], false, true)
      } else {
        this.selectedTopTenRow = {}
        this.statsTableColumns = header[name].topagents.meta.columns
        this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_RESET_STATUS)
        this.statsTableData.models = _.cloneDeep(this.tempTableData.models)
        this.$nextTick(() => {
          this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_SUCCESS)
          this.$nextTick(() => {
            this.setTableHeight()
          })
        })
      }
      this.$store
        .dispatch(HRLY_INSIGHT_STATISTICS_LIST_REQ, {
          path: this.$router.currentRoute.meta.name,
          name: this.$router.currentRoute.meta.title,
          os: this.$router.currentRoute.meta.os,
          queryDate: this.insightsDateRangeUserSetting,
          entity: this.selectedTopTenRow[group]
        })
        .then(stats => {
          this.tempHrlyHostStats = _.cloneDeep(stats)
          this.hrlyStats = stats
          this.$store.dispatch(HRLY_INSIGHT_STATISTICS_LIST_SUCCESS)
        })
    },
    chartClickFunction (item) {
      let group = this.$router.currentRoute.meta.group
      let hrlySelection = this.hrlyStats.statistics[item._index]
      this.$store
        .dispatch(HRLY_INSIGHT_STATISTICS_LIST_REQ, {
          path: this.$router.currentRoute.meta.name,
          name: this.$router.currentRoute.meta.title,
          os: this.$router.currentRoute.meta.os,
          entity: this.selectedTopTenRow[group],
          customDate: {
            starttime: hrlySelection.timestampMillis,
            endtime: hrlySelection.timestampMillis + HR_TO_MILLISECONDS
          }
        })
        .then(queryResult => {
          this.hrlyStats = queryResult
          this.$store.dispatch(HRLY_INSIGHT_STATISTICS_LIST_SUCCESS)
        })
    },
    chartUnclickFunction () {
      let group = this.$router.currentRoute.meta.group
      this.$store.dispatch(HRLY_INSIGHT_STATISTICS_LIST_RESET_STATUS)
      setTimeout(() => {
        if (_.isEmpty(this.selectedTopTenRow[group])) {
          this.hrlyStats = _.cloneDeep(this.tempHrlyStats)
        } else {
          this.hrlyStats = _.cloneDeep(this.tempHrlyHostStats)
        }
        this.$store.dispatch(HRLY_INSIGHT_STATISTICS_LIST_SUCCESS)
      }, 500)
    },
    getHourlyStats () {
      this.$store
        .dispatch(HRLY_INSIGHT_STATISTICS_LIST_REQ, {
          path: this.$router.currentRoute.meta.name,
          name: this.$router.currentRoute.meta.title,
          os: this.$router.currentRoute.meta.os,
          queryDate: this.insightsDateRangeUserSetting
        })
        .then(stats => {
          this.tempHrlyStats = _.cloneDeep(stats)
          this.hrlyStats = stats
          this.$store.dispatch(HRLY_INSIGHT_STATISTICS_LIST_SUCCESS)
        })
    },
    fetchInsights (tabSelection) {
      this.currentTopTenSelection = tabSelection
      this.isTopTenStatsLoading = true
      this.isStatsTableLoading = true
      switch (tabSelection) {
        case 'bottom':
          this.$store
            .dispatch(BOTTOM_INSIGHT_STATISTICS_LIST_REQ, {
              path: this.$router.currentRoute.meta.name,
              queryDate: this.insightsDateRangeUserSetting,
              os: this.$router.currentRoute.meta.os
            })
            .then(
              stats => {
                this.topStats = stats
                this.$store.dispatch(BOTTOM_INSIGHT_STATISTICS_LIST_SUCCESS)
                this.isTopTenStatsLoading = false
                this.getPrivExecHostStats(tabSelection, _.map(stats, this.$router.currentRoute.meta.group))
              },
              errMsg => {
                this.isTopTenStatsLoading = false
              }
            )

          break
        case 'new':
          this.$store
            .dispatch(NEW_INSIGHT_STATISTICS_LIST_REQ, {
              path: this.$router.currentRoute.meta.name,
              queryDate: this.insightsDateRangeUserSetting,
              os: this.$router.currentRoute.meta.os
            })
            .then(
              stats => {
                this.topStats = stats
                this.$store.dispatch(NEW_INSIGHT_STATISTICS_LIST_SUCCESS)
                this.isTopTenStatsLoading = false
                this.getPrivExecHostStats(tabSelection, _.map(stats, this.$router.currentRoute.meta.group))
              },
              errMsg => {
                this.isTopTenStatsLoading = false
              }
            )

          break
        default:
          this.$store
            .dispatch(TOP_INSIGHT_STATISTICS_LIST_REQ, {
              path: this.$router.currentRoute.meta.name,
              queryDate: this.insightsDateRangeUserSetting,
              os: this.$router.currentRoute.meta.os
            })
            .then(
              stats => {
                this.topStats = stats
                this.$store.dispatch(TOP_INSIGHT_STATISTICS_LIST_SUCCESS)
                this.isTopTenStatsLoading = false
                this.getPrivExecHostStats(tabSelection, _.map(stats, this.$router.currentRoute.meta.group))
              },
              errMsg => {
                this.isTopTenStatsLoading = false
              }
            )
      }
    },
    getPrivExecHostStats (tabSelection, entity, newCopy = true, showChildren = false) {
      if (_.isEmpty(entity)) {
        if (!_.isEmpty(this.statsTableData)) {
          this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_RESET_STATUS)
          this.statsTableData.models.length = 0
          this.$nextTick(() => {
            this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_SUCCESS)
            this.$nextTick(() => {
              this.setTableHeight()
            })
          })
        } else {
          this.statsTableData = new IQCollection()
          this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_SUCCESS)
        }
        this.isStatsTableLoading = false
        return true
      }
      this.$store
        .dispatch(INSIGHT_HOST_STATISTICS_LIST_REQ, {
          path: this.$router.currentRoute.meta.name,
          group: this.$router.currentRoute.meta.group,
          queryDate: this.insightsDateRangeUserSetting,
          os: this.$router.currentRoute.meta.os,
          position: tabSelection,
          entity: entity,
          showChildren: showChildren
        })
        .then(stats => {
          if (newCopy) {
            this.tempTableData = _.cloneDeep(stats)
          }
          this.statsTableData = stats
          this.isStatsTableLoading = false
          this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_SUCCESS)
          this.$nextTick(() => {
            this.setTableHeight()
          })
        })
    },
    setTableHeight () {
      let tableBodyElm = this.$el.querySelector('.el-table__body-wrapper')
      if (tableBodyElm) {
        tableBodyElm.style.height = `${this.$el.parentElement.clientHeight - 500}px`
      }
    }
  },
  computed: {
    ...mapGetters([
      'navStatus',
      'insightsDateRangeUserSetting',
      'agentListReqStatus',
      'insightHostStatisticsReqStatus',
      'hrlyInsightStatisticsReqStatus'
    ]),
    isChartLoading () {
      return this.hrlyInsightStatisticsReqStatus === 'loading'
    },
    isNavLoaded () {
      return this.navStatus === 'saved'
    }
  },
  watch: {
    insightsDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.getHourlyStats()
          this.fetchInsights(this.$router.currentRoute.query.view)
        }
      }
    }
  },
  beforeDestroy () {
    this.$store.dispatch(INSIGHT_HOST_STATISTICS_LIST_RESET_STATUS)
  },
  components: {
    PageHeaders,
    BarChartJs,
    HorizontalBarChartJs,
    TreeTableElement,
    TopTenBarChartCard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/text.css';
@import 'assets/styles/icon.css';

h6 {
  text-transform: unset;
  letter-spacing: unset;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 10px;
}

.c-stats_row {
  height: 300px;
  margin-bottom: 20px;
}

.c-stats_row_table {
  height: calc(100%-350px);
}

.c-stats_row_timeseries {
  height: 100%;
}

.c-stats_row_title {
  height: 24px;
  text-align: center;
}

.table-data {
  >>> .el-tabs__header {
    margin: 0;
  }
}

.page-table {
  width: 100%;
  height: calc(100%-300px);
  overflow: scroll;
}

>>> .chartjs-render-monitor {
  border-right: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/insights/RenderInsights.vue